import { BRAND } from "../brand";

const DEFAULT_CHAT_OPENING_MESSAGES = [
  "What do you want to do with B2B video?",
  "Let me ping the owner. If you can wait a minute or two, he loves to grab messages and respond in real time. Send your question and we'll do our best.",
];

/** Static opener copy shown before the visitor sends their first message. */
export const CHAT_OPENING_MESSAGES =
  BRAND.marketing?.chatOpeners || DEFAULT_CHAT_OPENING_MESSAGES;

export const CHAT_PLACEHOLDER =
  BRAND.marketing?.chatPlaceholder || "Tell us what you're trying to do with B2B video…";
